export var ServicePublisherAllowListMediaType;
(function (ServicePublisherAllowListMediaType) {
    ServicePublisherAllowListMediaType["NONE"] = "NONE";
    ServicePublisherAllowListMediaType["VIDEO"] = "VIDEO";
    ServicePublisherAllowListMediaType["AUDIO"] = "AUDIO";
    ServicePublisherAllowListMediaType["DISPLAY"] = "DISPLAY";
})(ServicePublisherAllowListMediaType || (ServicePublisherAllowListMediaType = {}));
export var PublisherAllowListMediaType;
(function (PublisherAllowListMediaType) {
    PublisherAllowListMediaType["VIDEO"] = "Video";
    PublisherAllowListMediaType["AUDIO"] = "Audio";
    PublisherAllowListMediaType["DISPLAY"] = "Display";
})(PublisherAllowListMediaType || (PublisherAllowListMediaType = {}));
export var ServicePublisherAllowListStatus;
(function (ServicePublisherAllowListStatus) {
    ServicePublisherAllowListStatus[ServicePublisherAllowListStatus["READY"] = 200] = "READY";
    ServicePublisherAllowListStatus[ServicePublisherAllowListStatus["ARCHIVED"] = 500] = "ARCHIVED";
})(ServicePublisherAllowListStatus || (ServicePublisherAllowListStatus = {}));
export var PublisherAllowListStatus;
(function (PublisherAllowListStatus) {
    PublisherAllowListStatus["READY"] = "Ready";
    PublisherAllowListStatus["ARCHIVED"] = "Archived";
})(PublisherAllowListStatus || (PublisherAllowListStatus = {}));
export const serviceToPublisherAllowListStatus = (status) => {
    switch (status) {
        case ServicePublisherAllowListStatus.READY:
            return PublisherAllowListStatus.READY;
        case ServicePublisherAllowListStatus.ARCHIVED:
            return PublisherAllowListStatus.ARCHIVED;
        default:
            return undefined;
    }
};
export const publisherAllowListStatusToService = (status) => {
    switch (status) {
        case PublisherAllowListStatus.READY:
            return ServicePublisherAllowListStatus.READY;
        case PublisherAllowListStatus.ARCHIVED:
            return ServicePublisherAllowListStatus.ARCHIVED;
        default:
            return undefined;
    }
};
export const serviceToPublisherAllowListPubs = (pubs) => {
    return pubs?.map((pub) => ({
        pubId: pub.pub_id,
        name: pub.pub_name,
        createdBy: pub.created_by,
        createdAt: pub.created_at ? new Date(pub.created_at.seconds * 1000) : undefined
    }));
};
export const publisherAllowListPubsToService = (pubs) => {
    return pubs?.map((pub) => ({
        pub_id: pub.pubId,
        name: pub.pubName
    }));
};
export const serviceToPublisherAllowListMediaType = (media_type) => {
    switch (media_type) {
        case ServicePublisherAllowListMediaType.VIDEO:
            return PublisherAllowListMediaType.VIDEO;
        case ServicePublisherAllowListMediaType.AUDIO:
            return PublisherAllowListMediaType.AUDIO;
        case ServicePublisherAllowListMediaType.DISPLAY:
            return PublisherAllowListMediaType.DISPLAY;
        default:
            return undefined;
    }
};
export const publisherAllowListMediaTypeToService = (mediaType) => {
    switch (mediaType) {
        case PublisherAllowListMediaType.VIDEO:
            return ServicePublisherAllowListMediaType.VIDEO;
        case PublisherAllowListMediaType.AUDIO:
            return ServicePublisherAllowListMediaType.AUDIO;
        case PublisherAllowListMediaType.DISPLAY:
            return ServicePublisherAllowListMediaType.DISPLAY;
        default:
            return ServicePublisherAllowListMediaType.NONE;
    }
};
export const serviceToPublisherAllowList = (base) => {
    const { id, name, parent_id, created_at: { seconds: created } = { seconds: 0 }, updated_at: { seconds: updated } = { seconds: 0 }, created_by: createdBy, updated_by: updatedBy, status: AllowListStatus } = base;
    const pubs = serviceToPublisherAllowListPubs(base.pubs);
    const mediaType = serviceToPublisherAllowListMediaType(base.media_type);
    const status = serviceToPublisherAllowListStatus(AllowListStatus);
    return {
        id,
        name,
        ...("parent_id" in base && { parentId: parent_id }),
        ...("created_at" in base && { createdAt: new Date(created * 1000) }),
        ...("updated_at" in base && { updatedAt: new Date(updated * 1000) }),
        ...("created_by" in base && { createdBy }),
        ...("updated_by" in base && { updatedBy }),
        ...("pubs" in base && { pubs }),
        ...("media_type" in base && { mediaType }),
        ...("status" in base && { status })
    };
};
export const publisherAllosListToService = (base) => {
    const { id, name, parentId, createdBy, updatedBy, status: service_status } = base;
    const servicePubs = publisherAllowListPubsToService(base.pubs);
    const media_type = publisherAllowListMediaTypeToService(base.mediaType) || ServicePublisherAllowListMediaType.NONE;
    const status = publisherAllowListStatusToService(service_status);
    return {
        id,
        name,
        ...("parentId" in base && { parent_id: parentId }),
        ...("createdby" in base && { created_by: createdBy }),
        ...("updatedby" in base && { updated_by: updatedBy }),
        ...("pubs" in base && { pubs: servicePubs }),
        ...("mediaType" in base && { media_type }),
        ...("status" in base && { status })
    };
};
//# sourceMappingURL=allowList.js.map